import React from 'react';
import './divider.less';

export const Divider = () => (
    <div className="filters-section-divider-container">
        <hr className="filters-section-divider" />
    </div>
);
